// ------------------------------------
// Constants
// ------------------------------------
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY'
export const RESET_CART = 'RESET_CART'

export const SET_CART_ITEMS = 'SET_CART_ITEMS'

// ------------------------------------
// Actions
// ------------------------------------
export const addProduct = ({ product }) => ({
    type: ADD_PRODUCT,
    product
});
export const removeProduct = ({ key }) => ({
    type: REMOVE_PRODUCT,
    key
});
export const updateQuantity = ({ key, quantity }) => ({
    type: UPDATE_QUANTITY,
    key,
    quantity
});

export const resetCart = () => ({
    type: RESET_CART
});

export const setCartItems = ({items}) => ({
    type: SET_CART_ITEMS,
    items
});

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    show: false,
    items: []
};

const cart = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PRODUCT:
            return {
                ...state,
                items: [...state.items, action.product]
            }
        case REMOVE_PRODUCT:
            return {
                ...state,
                items: [
                    ...state.items.slice(0, action.key),
                    ...state.items.slice(action.key + 1)
                ],
            }
        case UPDATE_QUANTITY:
            return {
                ...state,
                items: state.items.map((item, key) => key === action.key ?
                    { ...item, quantity: action.quantity } :
                    item
                )
            }
        case RESET_CART:
            return {
                ...state,
                items: initialState.items
            }
        case SET_CART_ITEMS:
            return {
                ...state,
                items: action.items
            }
        default:
            return state
    }
};

export default cart


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/modules/cart.js